class ProductTempalate extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initMedias();
        this.initProductForm();

        this.firstInit = false;

        this.toggleText();

        this.querySelectorAll('.matiere_label').forEach((elem) => {
            elem.addEventListener('click', (e) => {
                let id = e.target.closest('[data-index]').getAttribute('data-index')
                console.log(`[data-index="matiere-${id}"]`)
                document.querySelectorAll('.product-form__checklist').forEach((element) => {
                    element.classList.add('hidden')
                })


                console.log(`[data-index="matiere-${id}"]`)
                document.querySelectorAll(`[data-index="matiere-${id}"]`).forEach((element) => {
                    element.classList.remove('hidden')
                })

                let handle = e.target.closest('[data-handle-current]').getAttribute('data-handle-current');
                console.log(handle);

                // Find which variant picker contains this handle and make it visible
                let clickedInput = e.target.closest('input');
                if (clickedInput) {
                    let variantPickerParent = clickedInput.closest('.variant_picker--product');
                    if (variantPickerParent) {
                        // Hide all variant pickers
                        document.querySelectorAll('.variant_picker--product').forEach((picker) => {
                            picker.classList.add('hidden');
                        });
                        // Show the one that was clicked
                        variantPickerParent.classList.remove('hidden');
                    }
                }
                
                const isLp2 = window.location.pathname.includes('lp-2');
                
                if (handle.includes('satin-de-coton') && !isLp2) {
                    // document.querySelectorAll('.product-pack').forEach((pack, index) => {
                    //     if (index === 0) {
                    //         pack.style.display = 'block';
                    //         pack.classList.add('active');
                    //     } else {
                    //         pack.style.display = 'none';
                    //         pack.classList.remove('active');
                    //     }
                    // });
                } else {
                    document.querySelectorAll('.product-pack').forEach((pack, index) => {
                        pack.style.display = 'block';
                        if (index === 0) {
                            pack.classList.add('active');
                        } else {
                            pack.classList.remove('active');
                        }
                    });
                }

                document.querySelectorAll('.product-form__gift').forEach((gift) => {
                    console.log(gift);

                    let productHandle = gift.getAttribute('data-product-handle');
                    console.log(productHandle);
                    if (productHandle) {
                        let handles = productHandle.split(',');
                        handles = handles.map(handle => handle.trim().replace(/\s+/g, '-').toLowerCase());
                        if (handles.includes(handle)) {
                            gift.classList.remove('hidden');
                        } else {
                            gift.classList.add('hidden');
                        }
                    }
                });

            })
        })
    }


    toggleText() {
        const buttons = this.querySelectorAll('.button-text');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const card = button.closest('.text-button');
                console.log(card);
                let text_open = card.dataset.content;
                let text_close = card.dataset.contentClosed;

                console.log(text_open);
                console.log(text_close);

                const paragraph = card.querySelector('.text-to-change');
                if (paragraph) {
                    paragraph.classList.toggle('paragraph-card--open');
                }

                if (paragraph.classList.contains('paragraph-card--open')) {
                    paragraph.innerHTML = text_open;
                    button.textContent = 'Réduire';
                } else {
                    paragraph.innerHTML = text_close;
                    button.textContent = 'Voir plus';
                }
            });
        });
    }

    initMedias() {
        this.swiper2 = new Swiper(this.querySelector('.swiper-thumbs'), {
            slidesPerView: 4,
            spaceBetween: 6,
            slideToClickedSlide: true,
        });

        this.swiper = new Swiper(this.querySelector('.swiper-main'), {
            slidesPerView: 1,
            spaceBetween: 10,
            slideToClickedSlide: true,
            thumbs: {
                swiper: this.swiper2,
            },
            navigation: {
                nextEl: this.querySelector('.product-form__media-container .swiper-next'),
                prevEl: this.querySelector('.product-form__media-container .swiper-prev'),
            },
            on: {
              init() {
                const v = this.slides[this.activeIndex]?.querySelector('video');
                if (v) {
                  v.muted = true;
                  v.playsInline = true;
                  v.play();
                }
              },
              slideChange() {
                this.slides.forEach((slide, idx) => {
                  const v = slide.querySelector('video');
                  if (!v) return;
                  if (idx === this.activeIndex) {
                    v.muted = true;
                    v.playsInline = true;
                    v.play();
                  } else {
                    v.pause();
                    v.currentTime = 0;
                  }
                });
              }
            }
        });
    }

  refreshMedias() {
    this.swiper.destroy();
    this.swiper2.destroy();
    this.initMedias();
    this.swiper2.slideTo(0);
    this.swiper.slideTo(0);
  }

  


    initProductForm() {


        //  init the faq items
        if (this.querySelector('.tabs-section__item-title')) {
            this.querySelectorAll(".faq-item-title").forEach((button) => {
                button.addEventListener("click", this.toggleFaqItem.bind(this));
            });
        }

        this.calculateShipping();

        //  open the drawer
        if (this.querySelector('[data-open-drawer]')) {
            this.querySelector('[data-open-drawer]').addEventListener('click', (e) => {
                this.openDrawer(e);
            });
        }

        if (this.querySelector('[open-third-step]')) {
            this.querySelector('[open-third-step]').addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.product-form__third-step').classList.add('open');
            });
        }

        if (this.querySelector('.product-packs__icon-close-third ')) {
            this.querySelector('.product-packs__icon-close-third').addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.product-form__third-step').classList.remove('open');
            });
        }

        this.initFormSubmit();

        // init reassurance swiper 
        if (this.querySelector('.reassurance-swiper')) {
            new Swiper(this.querySelector('.reassurance-swiper'), {
                slidesPerView: 1,
                spaceBetween: 10,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                loop: true,
                pagination: {
                    el: this.querySelector('.reassurance-swiper-pagination'),
                    clickable: true,
                },
            });
        }

        //  close the drawer 
        if (this.querySelector('.product-packs__icon')) {
            this.querySelector('.product-packs__icon').addEventListener('click', (e) => {
                this.closeDrawer(e);
            });
        }

        if (this.querySelector('.product-form__form-container--overlay')) {
            this.querySelector('.product-form__form-container--overlay').addEventListener('click', (e) => {
                this.closeDrawer(e);
            });
        }


        //  toggle the variant picker for each product pack
        this.querySelectorAll('.product-pack').forEach((elem) => {
            elem.addEventListener('click', (e) => {
                let currentId = e.currentTarget.getAttribute('data-product-id');
                let variantPicker = document.querySelector('.variant_picker--product[data-product-id="' + currentId + '"]');

                document.querySelectorAll('.variant_picker--product').forEach((pack) => {
                    pack.classList.add('hidden');
                });

                let otherVariantPicker = document.querySelector('.variant_picker--product:not([data-product-id="' + currentId + '"])')
                variantPicker.classList.remove('hidden');
                let checkedIndexes = [];
                otherVariantPicker.querySelectorAll('fieldset').forEach((fieldset) => {
                    let checkedInput = fieldset.querySelector('input:checked');
                    if (checkedInput) {
                        let inputs = fieldset.querySelectorAll('input');
                        let index = Array.from(inputs).indexOf(checkedInput);
                        checkedIndexes.push(index);
                    } else {
                        checkedIndexes.push(0);
                    }
                });

                let targetVariantRadios = variantPicker.querySelector('variant-radios');
                if (targetVariantRadios) {
                    // Track if any input actually changed to dispatch event only once at the end
                    let hasChanged = false;
                    targetVariantRadios.querySelectorAll('fieldset').forEach((fieldset, index) => {
                        let targetInputs = fieldset.querySelectorAll('input');
                        let targetIndex = checkedIndexes[index] || 0;
                        if (targetInputs[targetIndex]) {
                            // Only set checked if not already checked (avoid triggering unnecessary events)
                            if (!targetInputs[targetIndex].checked) {
                                targetInputs[targetIndex].checked = true;
                                hasChanged = true;
                            }
                        }
                    });
                    // Only dispatch change event once if something actually changed
                    if (hasChanged) {
                        targetVariantRadios.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });
        })

        //  set the first product pack as active
        this.querySelectorAll('.product-pack').forEach((pack) => {
            pack.addEventListener('click', (e) => {
                e.preventDefault();
                this.querySelectorAll('.product-pack').forEach((p) => p.classList.remove('active'));
                pack.classList.add('active');
                if (pack.getAttribute('data-hide-shipping') == 'true') {
                    if (this.querySelector('.variant_picker--packs__header-item--shipping')) {
                        this.querySelector('.variant_picker--packs__header-item--shipping').classList.add('hidden');
                    }
                } else {
                    if (this.querySelector('.variant_picker--packs__header-item--shipping')) {
                        this.querySelector('.variant_picker--packs__header-item--shipping').classList.remove('hidden');
                    }

                }

            });
        });

        if (this.firstInit = false) {
            this.querySelector('.variant_picker--product:not(.hidden)')?.querySelectorAll('variant-radios').forEach((variantRadios) => {
                variantRadios.querySelectorAll('fieldset').forEach((fieldset) => {
                    let inputs = fieldset.querySelectorAll('label');
                    if (inputs.length > 0) {
                        inputs[0].checked = true;
                        inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            })
        }
    }

    initFormSubmit() {
        let drawer = false;
        if (this.querySelector('.product-form__form--drawer')) {
            drawer = true;
            this.querySelector('.product-form__email-form input').addEventListener('change', (e) => {
                // if email is valid, enable the submit button
                const emailInput = e.currentTarget;
                const submitButton = this.querySelector('.product-form__third-step--buttons button.button--primary');
                if (emailInput.validity.valid) {
                    submitButton.removeAttribute('disabled');
                } else {
                    submitButton.setAttribute('disabled', 'disabled');
                }
            })
        }

        this.querySelector('.product-form__third-step--buttons button.button--primary').addEventListener('click', (e) => {
            let items = [];
            items.push({
                id: Number(this.getAttribute('data-current-variant-id')),
                quantity: 1,
            });

            let data = {
                items: items,
                discount_code: 'FIRST10'
            };

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log('Success:', data);
                    window.SLIDECART_UPDATE(function (cart) {
                        console.log('Cart updated:', cart);
                        window.SLIDECART_OPEN();
                    });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        });

        this.querySelectorAll('button[submit-form-basic]').forEach((button) => {
            button.addEventListener('click', (e) => {
                let items = [];
                items.push({
                    id: Number(this.getAttribute('data-current-variant-id')),
                    quantity: 1,
                });

                let data = {
                    items: items,
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        console.log('Success:', data);
                        window.SLIDECART_UPDATE(function (cart) {
                            console.log('Cart updated:', cart);
                            window.SLIDECART_OPEN();
                        });
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            });
        });
    }


    calculateShipping() {
        if (this.querySelector('.product-form__icon')) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(this.getAttribute('data-shipping-delay'));


            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString('fr-FR', {
                weekday: 'long', // Jour de la semaine en toutes lettres (ex. : Jeudi)
                day: 'numeric',  // Jour du mois en chiffres (ex. : 13)
                month: 'long'
            });

            for (let i = 0; i < document.querySelectorAll('.product-form__icon').length; i++) {
                let html = document.querySelectorAll('.product-form__icon')[i].innerHTML;
                if (html.indexOf('[date]') > -1) {
                    document.querySelectorAll('.product-form__icon')[i].innerHTML = html.replace('[date]', shipping_date_format);
                }
            }
        }
    }


    openDrawer(e) {
        e.preventDefault();
        const drawer = document.querySelector('.variant_picker--packs');
        drawer.classList.add('open');
        document.body.classList.add('overflow-hidden');
    }

    closeDrawer(e) {
        e.preventDefault();
        const drawer = document.querySelector('.variant_picker--packs');
        drawer.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }



}

customElements.define('product-template', ProductTempalate);